import { useEffect } from 'react';
import { useRoomContext } from '@livekit/components-react';
import { toast } from 'react-toastify';
import { RoomEvent } from 'livekit-client';

const RAISE_HAND_EVENT = 'RAISE_HAND';

const RaiseHandListener = () => {
  const room = useRoomContext();

  useEffect(() => {
    if (!room) return;

    const onDataReceived = (payload, participant) => {
      const decoder = new TextDecoder();
      const strData = decoder.decode(payload);
      try {
        const data = JSON.parse(strData);
        if (data.type === RAISE_HAND_EVENT && participant) {
             const name = participant.name || participant.identity;
             toast.info(`${name} raised hand ✋`, {
                 position: "top-right",
                 autoClose: 3000,
                 hideProgressBar: false,
                 closeOnClick: true,
                 pauseOnHover: true,
                 draggable: true,
             });
        }
      } catch (e) {
        // ignore invalid json
      }
    };

    room.on(RoomEvent.DataReceived, onDataReceived);

    return () => {
      room.off(RoomEvent.DataReceived, onDataReceived);
    };
  }, [room]);

  return null;
};

export default RaiseHandListener;
